import { RouterView } from "vue-router";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildCards,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { EntityAudit } from "@modernary/mui/components/audit";
// Troubleshoot your routes using this - https://paths.esm.dev

/** @type {import('vue-router').RouterOptions['routes']} */

const names = {
  contracts: "Contract.Contracts",
  list: "Contract.ContractList",
  new: "Contract.ContractNew",
  base: "Contract.ContractBase",
  view: "Contract.ContractView",
  edit: "Contract.ContractEdit",
  notes: "Contract.ContractNotes",
  noteEdit: "Contract.ContractNoteEdit",
  noteNew: "Contract.ContractNoteNew",
  projects: "Contract.ContractProjects",
  documents: "Contract.ContractDocuments",
  documentEdit: "Contract.ContractDocumentEdit",
  documentNew: "Contract.ContractDocumentNew",
  audit: "Contract.ContractAudit",
  modifications: "Contract.ContractModifications",
  modificationEdit: "Contract.ContractModificationEdit",
  modificationNew: "Contract.ContractModificationNew",
};

export { names as contractRouteNames };

const contractRoutes = [
  {
    path: "/contract",
    name: names.contracts,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Contracts", lookupGroups: ["ContractStatus", "ContractType"] },
        component: () => import("@/views/contract/ContractList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/contract/ContractBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Contract", isNew: true },
            component: () => import("@/views/contract/ContractEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/contract/ContractBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Contract View" },
            component: () => import("@/views/contract/ContractView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Contract Edit", isForm: true },
            component: () => import("@/views/contract/ContractEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Contract Notes" },
            component: {
              render: () => <EntityNotes idField="contractId" routeNamePrefix="Contract.ContractNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Contract Note", isForm: true },
            component: () => import("@/views/contract/ContractNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Contract Note", isForm: true },
            component: () => import("@/views/contract/ContractNote.vue"),
          },
          {
            path: "projects",
            name: names.projects,
            meta: { title: "Contract Projects" },
            component: () => import("@/views/contract/ProjectChildList.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Contract Documents" },
            component: {
              render: () => <EntityDocumentsChildList entityType="contract" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Contract Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm entityType="contract" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Contract Document", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm entityType="contract" />,
            },
          },
          {
            path: "modifications",
            name: names.modifications,
            meta: { title: "Contract Modification" },
            component: () => import("@/views/contract/ContractModifications.vue"),
          },
          {
            path: "modifications/:modificationId(\\d+)",
            name: names.modificationEdit,
            meta: { title: "Edit Contract Modification", isForm: true },
            component: () => import("@/views/contract/ContractModification.vue"),
          },
          {
            path: "modifications/new",
            name: names.modificationNew,
            meta: { title: "Create Contract Modification", isForm: true },
            component: () => import("@/views/contract/ContractModification.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Contract Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Contract" />,
            },
          },
        ],
      },
    ],
  },
];
export default contractRoutes;
